import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getChild, getMaterialDetails } from "../../redux/material/actions";
import {
  Accordion,
  AccordionDetails,
  Typography,
  AccordionSummary,
} from "@mui/material";
import { MaterialSymbol } from "@datalake/towercontrol-banner";
export default function Asset(props) {
  const assetDetails = props?.assetDetails;
  const parent = props?.parent;
  const children = props?.children;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function selectParent(parent) {
    const materialParams = {
      serialNumber: parent.serial_number,
      orderId: parent?.order?.order_id,
      orderLine: parent?.order?.order_line,
    };
    dispatch(getMaterialDetails(materialParams));
    navigate("/materials/details/" + parent.serial_number);
  }

  function selectChild(child) {
    dispatch(getChild({ serial_number: child }));
    navigate("/materials/details/" + child);
  }

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<MaterialSymbol name="expand_more" />}
            >
              <Typography
                style={{
                  width: "100%",
                }}
              >
                <MaterialSymbol
                  name="web_asset"
                  style={{ marginRight: "1%", verticalAlign: "middle" }}
                />
                Asset
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table
                sx={{ minWidth: "30%" }}
                size="small"
                aria-label="client table"
              >
                <TableBody>
                  {assetDetails.map((row, i) => {
                    if (row?.value) {
                      return (
                        <TableRow>
                          <TableCell key={row.name + i + " namecell"}>
                            {row.name}
                          </TableCell>
                          <TableCell key={row.value + i + " valuecell"}>
                            {row.value}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
                  {parent ? (
                    <TableRow
                      hover
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        selectParent(parent);
                      }}
                    >
                      <TableCell>Parent</TableCell>
                      <TableCell>{parent?.serial_number}</TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </TableContainer>
        <TableContainer>
          {children ? (
            <Table
              sx={{ minWidth: "30%" }}
              size="small"
              aria-label="client table"
            >
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: "var(--ale-primary)",
                    color: "white",
                  }}
                  colSpan="100%"
                >
                  <MaterialSymbol
                    name="web_asset"
                    style={{ marginRight: "1%", verticalAlign: "middle" }}
                  />
                  Children
                </TableCell>
              </TableRow>
              {children.map((child, i) => {
                return (
                  <TableRow
                    hover
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      selectChild(child);
                    }}
                  >
                    <TableCell key={"child" + child?.serial_number + i}>
                      {child}
                    </TableCell>
                  </TableRow>
                );
              })}
            </Table>
          ) : null}
        </TableContainer>
      </div>
    </React.Fragment>
  );
}
